"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.veYETIStake = void 0;
const Decimal_1 = require("./Decimal");
/**
 * Represents the change between two states of a veYETI Stake.
 *
 * @public
 */
class veYETIStake {
    /** @internal */
    constructor(yetiStake = Decimal_1.Decimal.ZERO, veYETIGain = Decimal_1.Decimal.ZERO, veYETITotal = Decimal_1.Decimal.ZERO, totalUserYeti = Decimal_1.Decimal.ZERO, totalYeti = Decimal_1.Decimal.ZERO, yetiEarned = Decimal_1.Decimal.ZERO, rewardRate = Decimal_1.Decimal.ZERO, accumulationRate = Decimal_1.Decimal.ZERO, boostAmount = Decimal_1.Decimal.ZERO, boostFactor = Decimal_1.Decimal.ZERO, boostRewardRate = Decimal_1.Decimal.ZERO, boostBasePartition = Decimal_1.Decimal.ZERO, yetiStakeOnFarm = Decimal_1.Decimal.ZERO, boostSumOfFactors = Decimal_1.Decimal.ZERO, veYetiOnFarm = Decimal_1.Decimal.ZERO, boostTotalSupply = Decimal_1.Decimal.ZERO) {
        this.yetiStake = yetiStake;
        this.veYETIGain = veYETIGain;
        this.veYETITotal = veYETITotal;
        this.totalUserYeti = totalUserYeti;
        this.totalYeti = totalYeti;
        this.yetiEarned = yetiEarned;
        this.rewardRate = rewardRate;
        this.accumulationRate = accumulationRate;
        this.boostAmount = boostAmount;
        this.boostFactor = boostFactor;
        this.boostRewardRate = boostRewardRate;
        this.boostBasePartition = boostBasePartition;
        this.yetiStakeOnFarm = yetiStakeOnFarm;
        this.boostSumOfFactors = boostSumOfFactors;
        this.veYetiOnFarm = veYetiOnFarm,
            this.boostTotalSupply = boostTotalSupply;
    }
    get isEmpty() {
        return this.yetiStake.isZero && this.veYETIGain.isZero && this.veYETITotal.isZero;
    }
    /**
       * Compare to another instance of `YETIStake`.
       */
    equals(that) {
        return (this.yetiStake.eq(that.yetiStake) &&
            this.veYETIGain.eq(that.veYETIGain) &&
            this.veYETITotal.eq(that.veYETITotal));
    }
}
exports.veYETIStake = veYETIStake;
//# sourceMappingURL=veYETIStake.js.map